import Head from 'next/head'
import styles from './NewsLp.module.scss'
import BasicTitle from 'components/commons/BasicTitle/BasicTitle'
import Button from 'components/commons/Button/Button'
import { formatCreateDate } from 'lib/functions'

interface NewsItem {
  image?: string
  title: string
  date: string
  href: string
}

interface Topic {
  title: string
  date: string
  src: string
}

interface SectionTitle {
  title: string
  sub_title: string
}

interface Props {
  tagType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  inPocketList?: BlogItem[]
  techBlogList?: BlogItem[]
  topics?: Topic[]
}
interface BlogItem {
  image?: string
  title: string
  date: string
  href: string
}

const NewsSection = ({
  items,
  title,
  buttonLabel,
  buttonLink,
  titleText,
  src,
}: {
  items: NewsItem[]
  title: string
  buttonLabel: string
  buttonLink: string
  titleText: string
  src: string
}) => (
  <div className={styles.section}>
    <div className={`${styles.heading} Column_read ${styles.heading_other}`}>
      <div className={styles.heading_left}>
        <div className={styles.heading_left_img}>
          <img
            src={src}
            alt={title}
            className={title === 'in-Pocket' ? 'inPocket' : title === 'Tech Blog' ? 'techBlog' : ''}
          />
        </div>
        <p className={styles.heading_txt}>{titleText}</p>
      </div>
      <div className={`${styles.heading_btn} ${styles.heading_btn_other}`}>
        <Button text={buttonLabel} href={buttonLink} isExternal />
      </div>
    </div>
    <div className={styles.column_wrapper}>
      {items.map((item, index) => (
        <a key={index} className={styles.column_item} href={item.href} target="_blank" rel="noopener">
          <img src={item.image} alt={item.title} />
          <div className={styles.column_item_title}>
            <p>{item.title}</p>
            <span>{item.date}</span>
          </div>
        </a>
      ))}
    </div>
  </div>
)

const TopicsSection = ({
  topics,
  sectionTitle,
  tagType,
}: {
  topics: Topic[]
  sectionTitle: SectionTitle
  tagType: Props['tagType']
}) => (
  <div className={styles.wrapper_topics}>
    <BasicTitle sectionTitle={sectionTitle} tagType={tagType} />
    <div className={styles.wrapper_topics_items}>
      {topics.map((topic, index) => (
        <a key={index} className={styles.wrapper_topics_items_item} href={topic.src}>
          <div className={styles.wrapper_topics_items_item_data}>
            <span>{topic.date}</span>
            <p>{topic.title}</p>
          </div>
          <div className={styles.wrapper_topics_items_item_img}>
            <img src="/direction_red.svg" alt="direction_red" />
          </div>
        </a>
      ))}
    </div>
  </div>
)

const NewsLp: React.FC<Props> = ({ tagType = 'h3', inPocketList, techBlogList, topics }) => {
  const sectionTitle = { title: 'Topics', sub_title: 'トピックス' }

  return (
    <>
      <Head>
        <link rel="preload" href="/icon_external-link_black.svg" as="image" />
      </Head>
      <div className={styles.topics_section}>
        <div className={styles.wrapper}>
          {inPocketList ? (
            <NewsSection
              src="/images/logo/logo_in-pocket.png"
              items={inPocketList}
              title="in-Pocket"
              buttonLabel="in-Pocket"
              buttonLink="/in-pocket/"
              titleText="in-PocketはAitriaのメンバーが発信しているオウンドメディアです。「ひとつ時代の先を行く人」がポケットの中にとっておきたくなる話題をお伝えします。"
            />
          ) : (
            ''
          )}
          {techBlogList ? (
            <NewsSection
              src="/images/logo/logo_tackBlog.png"
              items={techBlogList}
              title="Tech Blog"
              buttonLabel="Tech Blog"
              buttonLink="https://tech.aitria.co.jp/"
              titleText="Aitria Tech Blogはエンジニアが業務を通じて得た知識やノウハウを共有する技術ブログです。他にも勉強会などの取り組みも発信しています。"
            />
          ) : (
            ''
          )}
          {topics ? <TopicsSection topics={topics} sectionTitle={sectionTitle} tagType={tagType} /> : ''}
          <div>
            <Button text="トピックス一覧" href="/news/page/1" />
          </div>
        </div>
      </div>
    </>
  )
}

export default NewsLp
